'use client'

export type HgSpotifyEmbedProps = {
  url: string
}

export const HgSpotifyEmbed = ({url}: HgSpotifyEmbedProps) => {
  const link = new URL(url)

  return (
    <iframe
      data-chromatic="ignore"
      style={{borderRadius: '12px'}}
      src={`https://open.spotify.com/embed${link.pathname}?theme=0`}
      width="100%"
      height="152"
      frameBorder="0"
      allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
      loading="lazy"
    ></iframe>
  )
}
